import React from 'react';
import IconWrap from '../../IconWrap';
const Minus = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M19.2 12c0 0.664 -0.058 1.2 -0.721 1.2H5.521C4.859 13.2 4.8 12.664 4.8 12c0 -0.664 0.059 -1.2 0.721 -1.2H18.48c0.662 0 0.72 0.536 0.72 1.2z"
    })));
};
Minus.displayName = 'Minus';
export default Minus;

//# sourceMappingURL=Minus.js.map